import { SET_MOT_HISTORY_REDUCER } from '../constants/get_lead_profile.constants';
import { GET_LEADS_MOT_HISTORY_REQUEST, GET_LEADS_MOT_HISTORY_REQUEST_SUCCESS, GET_LEADS_MOT_HISTORY_REQUEST_FAILURE } from '../constants/cap.constants';

const initialState = {
    loading: false,
    mot_history: null,
    error: null,
};

export const Lead_mot_history = (state = initialState, action) => {
    switch (action.type) {
    case GET_LEADS_MOT_HISTORY_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case SET_MOT_HISTORY_REDUCER:
        return {
            ...state,
            mot_history: action.payload,
        };
    case GET_LEADS_MOT_HISTORY_REQUEST_SUCCESS:
        return {
            ...state,
            mot_history: action.payload,
            loading: false,
        };
    case GET_LEADS_MOT_HISTORY_REQUEST_FAILURE:
        return {
            ...state,
            error: action.error,
            loading: false,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/mot_history.reducer.js